import { ArrowUpRight, ArrowDown } from "lucide-react";

const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/4f3190bd-1b22-40d9-b386-e9731f443b12/images/d81916106dd83c419bc5506224852a589bddc12c20af0a219dab7a40efebd65c.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 hero-mask" aria-hidden="true" />

      {/* Side meta column */}
      <div className="absolute hidden lg:flex flex-col items-center gap-6 left-10 top-1/2 -translate-y-1/2 z-10">
        <div className="w-px h-24 bg-slate-600" />
        <div className="text-[10px] tracking-[0.4em] text-slate-400 [writing-mode:vertical-rl] rotate-180">
          DAL 2022 — PAVIA / MILANO
        </div>
        <div className="w-px h-24 bg-slate-600" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-40 pb-20 md:pt-48 md:pb-32 min-h-[100svh] flex flex-col justify-between">
        <div className="max-w-4xl fade-up">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-px bg-[#FF5A1F]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold">
              Impresa Edile · Pavia & Milano
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="headline text-white text-[3.2rem] sm:text-[4.5rem] md:text-[6rem] lg:text-[7.5rem]"
          >
            Costruiamo <br />
            <span className="italic font-display font-medium text-slate-300">
              il valore
            </span>{" "}
            che resta.
          </h1>

          <p className="mt-8 max-w-xl text-base md:text-lg text-slate-300 leading-relaxed">
            Ristrutturazioni chiavi in mano, facciate condominiali fino a 30
            metri, finiture d'autore e carpenteria metallica.{" "}
            <span className="text-white">Una sola impresa, ogni cantiere.</span>
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#preventivo"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-between gap-6 bg-[#FF5A1F] hover:bg-[#EA450C] text-white px-7 py-5 text-base font-semibold tracking-wide transition-all w-full sm:w-auto sm:min-w-[280px]"
            >
              Richiedi preventivo gratuito
              <ArrowUpRight
                size={22}
                strokeWidth={2.5}
                className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </a>
            <a
              href="#servizi"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-between gap-6 bg-transparent border border-slate-500 hover:border-white text-white px-7 py-5 text-base font-semibold tracking-wide transition-colors w-full sm:w-auto sm:min-w-[280px]"
            >
              I nostri servizi
              <ArrowUpRight size={22} strokeWidth={2.5} />
            </a>
          </div>
        </div>

        {/* Bottom meta strip */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 border-t border-slate-700/60 pt-8">
          {[
            { v: "Dal 2022", l: "Impresa strutturata" },
            { v: "30m", l: "Ascensore ponteggio" },
            { v: "100%", l: "Manodopera interna" },
            { v: "Pavia / Milano", l: "Area operativa" },
          ].map((s) => (
            <div key={s.l} className="flex flex-col">
              <div className="text-2xl md:text-3xl font-bold text-white tabular tracking-tight">
                {s.v}
              </div>
              <div className="text-xs tracking-[0.2em] uppercase text-slate-400 mt-2">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 right-8 hidden md:flex items-center gap-3 text-slate-400 text-xs tracking-[0.3em] uppercase">
        Scorri <ArrowDown size={14} className="animate-bounce" />
      </div>
    </section>
  );
}
